<template>
    <v-file-input
        v-model="formInput"
        :label="mandatory ? `${$root.defaultMandatoryAsteriks} ${label} ` : label"
        dense
        outlined
        rounded
        :disabled="$attrs.readonly || $attrs.disabled"
        :error-messages="errorMessage"
        v-bind="$attrs"
        background-color="#fff"
        @change="resetErrorMessage($event)"
        v-on="$listeners"
    >
    </v-file-input>
</template>

<script>
export default {
    name: 'BFileInput',
    props: {
        toMutate: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        mandatory: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            store: null,
            propertyToMutate: null,
        };
    },
    computed: {
        formInput: {
            get() {
                return _.get(this.$store.state[this.store], this.propertyToMutate);
            },
            set(value) {
                this.$store.dispatch(`${this.store}/updateProperty`, { value, property: this.propertyToMutate });
            },
        },
        errorMessage() {
            const propertyToMutate =
                this.propertyToMutate !== this.toMutate.split('::')[1]
                    ? this.toMutate.split('::')[1]
                    : this.propertyToMutate;
            return _.get(this.$store.state[this.store].errorMessages, propertyToMutate);
        },
    },
    created() {
        [this.store, this.propertyToMutate] = this.toMutate.split('::');
    },
    methods: {
        resetErrorMessage() {
            if (this.errorMessage) {
                this.$store.commit(`${this.store}/SET_ERROR_MESSAGE`, {
                    value: [],
                    property: this.propertyToMutate,
                });
            }
        },
    },
};
</script>

<style></style>
